/* angular:styles/component:css;ca367802b47136e90c2adbec36c6d75ea67e0964855b9e071f9b8f8b95345c4e;/usr/src/app/src/app/shared/components/app-spinner/app-spinner.component.ts */
:host {
  contain: layout style;
}
.app-spinner-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  z-index: 9000;
  pointer-events: auto;
}
.app-spinner-ring {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  border-top: 4px solid var(--highlight_primary);
  border-right: 4px solid transparent;
  animation: app-spinner-rotation 1s linear infinite;
  position: relative;
}
.app-spinner-ring::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  box-sizing: border-box;
  border-bottom: 4px solid var(--highlight_secondary);
  border-left: 4px solid transparent;
}
@keyframes app-spinner-rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=app-spinner.component.css.map */
